import React from "react";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import VendorReportComponent from "./VendorReportComponent";
import Uri from "../../Network/Uri";

import {
  GET_VENDORS,
  GET_VENDOR_INVOICES,
  GET_PAYMENTS,
} from "../../Network/ApiPaths";

import getResponseClient from "../../Network/GetClientDataResponse";

let storeFresh;
let clientHost;

class VendorReportContainer extends React.Component {
  constructor(props) {
    super(props);
    this.yearList = [];
    const currentYear = new Date().getFullYear();
    for (let year = currentYear; year >= 2000; year--) {
      this.yearList.push(year);
    }
    const client = window.localStorage.getItem("clientAccess");
    storeFresh = JSON.parse(client);
    if (storeFresh !== null) {
      clientHost = storeFresh.host;
    }
    this.state = {
      /* ===========================
         Master Data
      ============================ */
      vendors: [],
      invoices: [],
      payments: [],
      /* ===========================
         Final Vendor Report
      ============================ */
      vendorReport: [],
      /* ===========================
         Charts
      ============================ */
      barChartData: [],
      selectedYear: new Date().getFullYear(),
      /* ===========================
         Search
      ============================ */
      searchText: "",
      selectedVendor: "",
      todaySummary: {
        invoiceCount: 0,
      },

      yesterdaySummary: {
        invoiceCount: 0,
      },

      lastWeekSummary: {
        invoiceCount: 0,
      },

      lastMonthSummary: {
        invoiceCount: 0,
      },
      /* ===========================
         Date Filters
      ============================ */
      reportType: "all",
      activePeriod: "all",
      fromDate: "",
      toDate: "",
      /* ===========================
         Summary Cards
      ============================ */
      totalVendors: 0,
      totalInvoiceAmount: 0,
      totalPaidAmount: 0,
      totalOutstandingBalance: 0,
      totalPendingInvoices: 0,
      /* ===========================
          Pending Payments
      ============================ */
      showPendingPayments: false,
      pendingPaymentsTable: [],
      /* ===========================
          Vendor bar charts
      ============================ */
      paymentComparisonChartData: [],
      paymentComparisonYear: new Date().getFullYear(),
      /* ===========================
          Vendor + Month Comparison
      ============================ */
      vendorMonthChartData: [],
      vendorMonth: "all",
      vendorMonthYear: new Date().getFullYear(),
      /* ===========================
         Loading
      ============================ */
      loading: false,
      /* ===========================
         Refresh Flag
      ============================ */
      refresh: false,
    };
  }
  /* =====================================================
        Lifecycle Methods
  ====================================================== */
  componentDidMount() {
    this.fetchAllData();
  }

  componentDidUpdate(prevProps, prevState) {
    const filterChanged =
      prevState.activePeriod !== this.state.activePeriod ||
      prevState.fromDate !== this.state.fromDate ||
      prevState.toDate !== this.state.toDate ||
      prevState.selectedVendor !== this.state.selectedVendor ||
      prevState.searchText !== this.state.searchText ||
      prevState.reportType !== this.state.reportType;
    const vendorMonthChanged =
      prevState.vendorMonth !== this.state.vendorMonth ||
      prevState.vendorMonthYear !== this.state.vendorMonthYear;
    const paymentComparisonChanged =
      prevState.paymentComparisonYear !== this.state.paymentComparisonYear;
    /* ==========================================
       NORMAL VENDOR REPORT
    ========================================== */
    if (filterChanged) {
      this.generateVendorReport();
      if (this.state.showPendingPayments) {
        this.preparePendingPaymentsTable();
      }
    }
    /* ==========================================
       TOTAL VS PAID CHART
    ========================================== */
    if (filterChanged || paymentComparisonChanged) {
      this.preparePaymentComparisonChart();
    }
    /* ==========================================
       VENDOR + MONTH CHART
    ========================================== */
    if (filterChanged || vendorMonthChanged) {
      this.prepareVendorMonthChart();
    }
  }

  fetchAllData = () => {
    this.setState({
      loading: true
    });
    let vendors = null;
    let invoices = null;
    let payments = null;

    const tryGenerate = () => {

      if (vendors !== null && invoices !== null && payments !== null) {
        this.setState(
          {
            vendors,
            invoices,
            payments,
            loading: false
          },
          () => {
            this.generateVendorReport();
            this.preparePaymentComparisonChart();
            this.prepareVendorMonthChart();
          }
        );
      }
    };

    // Load Vendors
    const vendorPath = new Uri(clientHost + GET_VENDORS)
      .addQueryParam("store_id", storeFresh.storeId);
    getResponseClient(
      vendorPath,
      storeFresh.key,
      (response) => {
        console.log("VendorReport - Vendors:", response);
        vendors = (response.result || []).sort((a, b) => {
          const nameA = (a.vendor_name || "").trim();
          const nameB = (b.vendor_name || "").trim();
          const getType = (name) => {
            if (/^[a-zA-Z]/.test(name)) return 1; // A-Z
            if (/^[0-9]/.test(name)) return 2;     // 0-9
            return 3;                              // Special characters
          };
          const typeA = getType(nameA);
          const typeB = getType(nameB);
          // First sort by category
          if (typeA !== typeB) {
            return typeA - typeB;
          }
          // Then alphabetical/numerical order
          return nameA.localeCompare(nameB, undefined, {
            numeric: true,
            sensitivity: "base"
          });
        });
        tryGenerate();
      },
      (error) => {
        console.error("VendorReport - Vendors Error:", error);
        vendors = [];
        tryGenerate();
      }
    );

    // Load Invoices
    const invoicePath = new Uri(clientHost + GET_VENDOR_INVOICES)
      .addQueryParam("store_id", storeFresh.storeId);
    getResponseClient(
      invoicePath,
      storeFresh.key,
      (response) => {
        console.log("VendorReport - Invoices:", response);
        invoices = response.result || [];
        tryGenerate();
      },
      (error) => {
        console.error("VendorReport - Invoices Error:", error);
        invoices = [];
        tryGenerate();
      }
    );

    // Load Payments
    const paymentPath = new Uri(clientHost + GET_PAYMENTS)
      .addQueryParam("store_id", storeFresh.storeId);
    getResponseClient(
      paymentPath,
      storeFresh.key,
      (response) => {
        console.log("VendorReport - Payments:", response);
        payments = response.result || [];
        tryGenerate();
      },
      (error) => {
        console.error("VendorReport - Payments Error:", error);
        payments = [];
        tryGenerate();
      }
    );
  };
  getVendors = () => { this.fetchAllData(); };
  getInvoices = () => { this.fetchAllData(); };
  getPayments = () => { this.fetchAllData(); };
  refreshData = () => {
    this.setState(
      {
        loading: true
      },
      () => {
        this.fetchAllData();
      }
    );
  };
  /* =====================================================
      Search Handler
  ====================================================== */
  onSearchChange = (e) => {
    this.setState({
      searchText: e.target.value
    });
  };
  onVendorChange = (e) => {
    this.setState({
      selectedVendor: e.target.value
    });
  };

  /* =====================================================
      Date Filter Handler
  ====================================================== */
  onReportTypeChange = (e) => {
    this.setState({
      reportType: e.target.value
    });
  };
  onFromDateChange = (e) => {
    this.setState({
      fromDate: e.target.value
    });
  };
  onToDateChange = (e) => {
    this.setState({
      toDate: e.target.value
    });
  };
  applyDateFilter = () => {
    this.setState({
      activePeriod: "custom"
    });
  };
  clearDateFilter = () => {
    this.setState({
      fromDate: "",
      toDate: "",
      activePeriod: "all"
    });
  };
  resetFilters = () => {
    this.setState({
      reportType: "all",
      searchText: "",
      selectedVendor: "",
      fromDate: "",
      toDate: "",
      activePeriod: "all"
    });
  };
  changePeriod = (period) => {
    this.setState((prevState) => ({
      activePeriod:
        prevState.activePeriod === period
          ? "all"
          : period
    }));
  };

  preparePendingPaymentsTable = () => {
    const {
      invoices,
      payments,
      vendors,
      selectedVendor
    } = this.state;
    /* ==========================================
       FILTER INVOICES BY INVOICE DATE
       The selected period is based ONLY
       on invoice_date.
    ========================================== */
    let filteredInvoices = this.filterByDate(
      invoices || [],
      "invoice_date"
    );
    /* ==========================================
       FILTER INVOICES BY VENDOR
    ========================================== */
    if (selectedVendor !== "") {
      filteredInvoices = filteredInvoices.filter(
        invoice =>
          Number(invoice.vendor_id) ===
          Number(selectedVendor)
      );
    }
    /* ==========================================
       KEEP ALL PAYMENTS  
       IMPORTANT:
       DO NOT FILTER BY payment_date.
       A payment belongs to an invoice through:
         vendor_id + invoice_id
    ========================================== */
    const allPayments = payments || [];
    /* ==========================================
       CREATE PAYMENT MAP
       Key: vendor_id + invoice_id
       Value: TOTAL PAYMENT AMOUNT
    ========================================== */
    const paymentMap = {};
    allPayments.forEach(payment => {
      const invoiceId = Number(payment.invoice_id);
      const vendorId = Number(payment.vendor_id);
      if (!invoiceId || !vendorId) {
        return;
      }
      const key = `${vendorId}_${invoiceId}`;
      if (!paymentMap[key]) {
        paymentMap[key] = 0;
      }
      paymentMap[key] += Number(
        payment.payment_amount || 0
      );
    });
    /* ==========================================
       CREATE PENDING PAYMENT TABLE
    ========================================== */
    const pendingPayments = [];
    filteredInvoices.forEach(invoice => {
      /* ========================================
         INVOICE AMOUNT
      ======================================== */
      const invoiceAmount =
        Number(
          invoice.invoice_amount ||
          invoice.amount ||
          0
        );
      if (invoiceAmount <= 0) {
        return;
      }
      /* ========================================
         INVOICE ID
      ======================================== */
      const invoiceId =
        Number(
          invoice.id ||
          invoice.invoice_id
        );
      /* ========================================
         VENDOR ID
      ======================================== */
      const vendorId =
        Number(invoice.vendor_id);
      if (!invoiceId || !vendorId) {
        return;
      }
      /* ========================================
         PAYMENT KEY
      ======================================== */
      const key =
        `${vendorId}_${invoiceId}`;
      /* ========================================
         TOTAL PAID AMOUNT
         This includes ALL payments for this
         invoice, regardless of payment_date.
      ======================================== */
      const paidAmount =
        Number(paymentMap[key] || 0);
      /* ========================================
         PENDING AMOUNT
      ======================================== */
      const pendingAmount =
        Math.max(
          invoiceAmount - paidAmount,
          0
        );
      /* ========================================
         STATUS
         Determine status from actual amounts,
         NOT from invoice.status.
      ======================================== */
      let status = "NOT PAID";
      if (paidAmount >= invoiceAmount) {
        status = "PAID";
      }
      else if (paidAmount > 0) {
        status = "PARTIAL";
      }
      /* ========================================
         ONLY SHOW PENDING / PARTIAL INVOICES
      ======================================== */
      if (pendingAmount <= 0) {
        return;
      }
      /* ========================================
         FIND VENDOR
      ======================================== */
      const vendor =
        (vendors || []).find(
          item =>
            Number(item.id) === vendorId
        );
      /* ========================================
         ADD TABLE ROW
      ======================================== */
      pendingPayments.push({
        invoice_id:
          invoiceId,
        vendor_id:
          vendorId,
        vendor_name:
          vendor?.vendor_name ||
          invoice.vendor_name ||
          "-",
        invoice_date:
          invoice.invoice_date || "",
        invoice_amount:
          invoiceAmount,
        paid_amount:
          paidAmount,
        pending_amount:
          pendingAmount,
        status:
          status
      });
    });
    /* ==========================================
       SORT BY PENDING AMOUNT
       HIGH → LOW
    ========================================== */
    pendingPayments.sort(
      (a, b) =>
        Number(b.pending_amount) -
        Number(a.pending_amount)
    );
    /* ==========================================
       UPDATE TABLE
    ========================================== */
    this.setState({
      pendingPaymentsTable:
        pendingPayments
    });
  };

  togglePendingPayments = () => {
    this.setState(
      prevState => ({
        showPendingPayments:
          !prevState.showPendingPayments
      }),
      () => {
        if (this.state.showPendingPayments) {
          this.preparePendingPaymentsTable();
        }
      }
    );
  };

  prepareVendorMonthChart = () => {
    const {
      invoices = [],
      payments = [],
      vendors = [],
      vendorMonthYear
    } = this.state;

    const selectedYear = Number(vendorMonthYear);

    /*
     * ==========================================
     * CREATE PAYMENT MAP
     * vendor_id + invoice_id
     * ==========================================
     */
    const paymentMap = {};

    payments.forEach(payment => {
      const vendorId = Number(
        payment.vendor_id ||
        payment.vendorId
      );

      const invoiceId = Number(
        payment.invoice_id ||
        payment.invoiceId
      );

      if (!vendorId || !invoiceId) {
        return;
      }

      const key = `${vendorId}_${invoiceId}`;

      paymentMap[key] =
        Number(paymentMap[key] || 0) +
        Number(
          payment.amount ||
          payment.payment_amount ||
          payment.paid_amount ||
          0
        );
    });

    /*
     * ==========================================
     * CREATE VENDOR MAP
     * ==========================================
     */
    const vendorMap = {};

    vendors.forEach(vendor => {
      const vendorId = Number(
        vendor.id ||
        vendor.vendor_id
      );

      if (!vendorId) {
        return;
      }

      vendorMap[vendorId] =
        vendor.vendor_name ||
        "Unknown Vendor";
    });

    /*
     * ==========================================
     * GROUP ALL YEAR DATA BY VENDOR
     * ==========================================
     */
    const vendorTotals = {};

    invoices.forEach(invoice => {

      const vendorId = Number(
        invoice.vendor_id ||
        invoice.vendorId
      );

      const invoiceId = Number(
        invoice.id ||
        invoice.invoice_id
      );

      if (!vendorId || !invoiceId) {
        return;
      }

      /*
       * ----------------------------------------
       * Get invoice date
       * ----------------------------------------
       */
      const rawDate =
        invoice.invoice_date ||
        invoice.date ||
        invoice.invoiceDate;

      if (!rawDate) {
        return;
      }

      const invoiceDate = new Date(rawDate);

      if (isNaN(invoiceDate.getTime())) {
        return;
      }

      // ================================
      // YEAR FILTER
      // ================================
      if (invoiceDate.getFullYear() !== selectedYear) {
        return;
      }

      // ================================
      // MONTH FILTER
      // ================================
      if (this.state.vendorMonth !== "all") {
        const selectedMonth = Number(this.state.vendorMonth);

        if (invoiceDate.getMonth() !== selectedMonth) {
          return;
        }
      }
      /*
       * ----------------------------------------
       * Invoice amount
       * ----------------------------------------
       */
      const invoiceAmount = Number(
        invoice.invoice_amount ||
        invoice.amount ||
        0
      );

      /*
       * ----------------------------------------
       * Paid amount
       * ----------------------------------------
       */
      const paymentKey =
        `${vendorId}_${invoiceId}`;

      const paidAmount =
        Number(paymentMap[paymentKey] || 0);

      /*
       * ----------------------------------------
       * Create vendor entry
       * ----------------------------------------
       */
      if (!vendorTotals[vendorId]) {
        vendorTotals[vendorId] = {
          vendorId: vendorId,
          vendor: vendorMap[vendorId] ||
            `Vendor ${vendorId}`,
          totalAmount: 0,
          paidAmount: 0
        };
      }

      /*
       * ----------------------------------------
       * Add ALL months together
       * ----------------------------------------
       */
      vendorTotals[vendorId].totalAmount +=
        invoiceAmount;

      vendorTotals[vendorId].paidAmount +=
        paidAmount;
    });

    /*
     * ==========================================
     * CONVERT TO CHART DATA
     * ==========================================
     */
    const chartData = Object.values(vendorTotals)
      .sort((a, b) =>
        a.vendor.localeCompare(b.vendor)
      )
      .map(item => ({
        vendor: item.vendor,
        totalAmount: Number(
          item.totalAmount.toFixed(2)
        ),
        paidAmount: Number(
          item.paidAmount.toFixed(2)
        )
      }));

    console.log(
      "Vendor-wise Total vs Paid:",
      chartData
    );

    /*
     * ==========================================
     * UPDATE CHART
     * ==========================================
     */
    this.setState({
      vendorMonthChartData: chartData
    });
  };

  /* =====================================================
    Date Utility Functions
  ====================================================== */
  formatDate = (date) => {
    if (!date) return "";
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };
  getToday = () => {
    return this.formatDate(new Date());
  };
  getYesterday = () => {
    const date = new Date();
    date.setDate(date.getDate() - 1);
    return this.formatDate(date);
  };
  getLastWeekStart = () => {
    const date = new Date();
    const day = date.getDay();
    const daysSinceMonday = day === 0 ? 6 : day - 1;
    date.setDate(date.getDate() - daysSinceMonday - 7);
    return this.formatDate(date);
  };

  getLastWeekEnd = () => {
    const date = new Date();
    const day = date.getDay();
    const daysSinceMonday = day === 0 ? 6 : day - 1;
    date.setDate(date.getDate() - daysSinceMonday - 1);
    return this.formatDate(date);
  };

  getPreviousMonthStart = () => {
    const date = new Date();
    date.setMonth(date.getMonth() - 1);
    date.setDate(1);
    return this.formatDate(date);
  };

  getPreviousMonthEnd = () => {
    const date = new Date();
    date.setDate(0); // Last day of previous month
    return this.formatDate(date);
  };
  /* =====================================================
      Date Filter
  ====================================================== */
  filterByDate = (records, dateField) => {
    if (!Array.isArray(records)) return [];
    let filteredRecords = [...records];
    const today = this.getToday();
    const yesterday = this.getYesterday();
    switch (this.state.activePeriod) {
      case "all":
        // no filter — return all records
        break;
      case "today":
        filteredRecords = filteredRecords.filter((item) => {
          return this.formatDate(item[dateField]) === today;
        });
        break;
      case "yesterday":
        filteredRecords = filteredRecords.filter((item) => {
          return this.formatDate(item[dateField]) === yesterday;
        });
        break;
      case "lastweek":
        filteredRecords = filteredRecords.filter((item) => {
          const value = this.formatDate(item[dateField]);
          return value >= this.getLastWeekStart() && value <= this.getLastWeekEnd();
        });
        break;
      case "lastmonth":
        const lastMonthStart = this.getPreviousMonthStart();
        const lastMonthEnd = this.getPreviousMonthEnd();

        filteredRecords = filteredRecords.filter((item) => {
          const value = this.formatDate(item[dateField]);
          return value >= lastMonthStart && value <= lastMonthEnd;
        });
        break;
      case "custom":
        if (this.state.fromDate) {
          filteredRecords = filteredRecords.filter((item) => {
            return (
              this.formatDate(item[dateField]) >=
              this.state.fromDate
            );
          });
        }
        if (this.state.toDate) {
          filteredRecords = filteredRecords.filter((item) => {
            return (
              this.formatDate(item[dateField]) <=
              this.state.toDate
            );
          });
        }
        break;
      default:
        break;
    }
    return filteredRecords;
  };
  /* =====================================================
    Calculate Period Summary
  ===================================================== */
  calculatePeriodSummary = (type) => {

    /* ==========================================
       START WITH ALL INVOICES
       
       Period is always based on invoice_date.
    ========================================== */

    let invoices = [
      ...(this.state.invoices || [])
    ];

    const today = this.getToday();
    const yesterday = this.getYesterday();

    /* ==========================================
       FILTER BY INVOICE DATE
    ========================================== */

    switch (type) {

      case "today":

        invoices = invoices.filter(
          invoice =>
            this.formatDate(
              invoice.invoice_date
            ) === today
        );

        break;

      case "yesterday":

        invoices = invoices.filter(
          invoice =>
            this.formatDate(
              invoice.invoice_date
            ) === yesterday
        );

        break;

      case "lastweek":

        invoices = invoices.filter(invoice => {

          const date =
            this.formatDate(
              invoice.invoice_date
            );

          return (
            date >= this.getLastWeekStart() &&
            date <= this.getLastWeekEnd()
          );
        });

        break;

      case "lastmonth": {

        const lastMonthStart =
          this.getPreviousMonthStart();

        const lastMonthEnd =
          this.getPreviousMonthEnd();

        invoices = invoices.filter(invoice => {

          const date =
            this.formatDate(
              invoice.invoice_date
            );

          return (
            date >= lastMonthStart &&
            date <= lastMonthEnd
          );
        });

        break;
      }

      default:
        break;
    }

    /* ==========================================
       ALL PAYMENTS
       
       DO NOT FILTER BY payment_date.
    ========================================== */

    const allPayments =
      this.state.payments || [];

    /* ==========================================
       CALCULATE PAID AMOUNT
       
       For every invoice selected by invoice_date,
       find its payments using invoice_id.
    ========================================== */

    let paidAmount = 0;

    invoices.forEach(invoice => {

      const invoiceId =
        Number(
          invoice.id ||
          invoice.invoice_id
        );

      const vendorId =
        Number(invoice.vendor_id);

      if (!invoiceId) {
        return;
      }

      const invoicePayments =
        allPayments.filter(
          payment =>
            Number(payment.invoice_id) ===
            invoiceId &&
            Number(payment.vendor_id) ===
            vendorId
        );

      const invoicePaidAmount =
        invoicePayments.reduce(
          (total, payment) =>
            total +
            Number(
              payment.payment_amount || 0
            ),
          0
        );

      paidAmount +=
        invoicePaidAmount;
    });

    /* ==========================================
       TOTAL INVOICE AMOUNT
    ========================================== */

    const invoiceAmount =
      invoices.reduce(
        (total, invoice) =>
          total +
          Number(
            invoice.invoice_amount ||
            invoice.amount ||
            0
          ),
        0
      );

    /* ==========================================
       RETURN SUMMARY
    ========================================== */

    return {
      invoiceCount:
        invoices.length,

      invoiceAmount:
        invoiceAmount,

      paidAmount:
        paidAmount,

      pendingAmount:
        Math.max(
          invoiceAmount - paidAmount,
          0
        )
    };
  };
  /* =====================================================
    Generate Vendor Report
  ====================================================== */
  generateVendorReport = () => {
    /* ==========================================
       DASHBOARD SUMMARY
       All period calculations are based on
       INVOICE DATE.
    ========================================== */

    const todaySummary =
      this.calculatePeriodSummary("today");

    const yesterdaySummary =
      this.calculatePeriodSummary("yesterday");

    const lastWeekSummary =
      this.calculatePeriodSummary("lastweek");

    const lastMonthSummary =
      this.calculatePeriodSummary("lastmonth");

    /* ==========================================
       FILTER INVOICES BY INVOICE DATE
       
       IMPORTANT:
       The current report period is determined
       ONLY by invoice_date.
    ========================================== */

    let filteredInvoices = this.filterByDate(
      this.state.invoices || [],
      "invoice_date"
    );

    /* ==========================================
       KEEP ALL PAYMENTS
       
       DO NOT filter payments by payment_date.
       
       Payments will be connected to invoices
       using invoice_id.
    ========================================== */

    const allPayments = this.state.payments || [];

    /* ==========================================
       VENDOR FILTER
    ========================================== */

    if (this.state.selectedVendor !== "") {
      const vendorId =
        Number(this.state.selectedVendor);

      filteredInvoices =
        filteredInvoices.filter(
          invoice =>
            Number(invoice.vendor_id) === vendorId
        );
    }

    /* ==========================================
       VENDOR REPORT
    ========================================== */

    const reportData = [];

    this.state.vendors.forEach((vendor) => {

      /* Skip other vendors when vendor selected */

      if (
        this.state.selectedVendor !== "" &&
        Number(vendor.id) !==
        Number(this.state.selectedVendor)
      ) {
        return;
      }

      /* ========================================
         INVOICES FOR THIS VENDOR
      ======================================== */

      const vendorInvoices =
        filteredInvoices.filter(
          invoice =>
            Number(invoice.vendor_id) ===
            Number(vendor.id)
        );

      if (vendorInvoices.length === 0) {
        return;
      }

      /* ========================================
         GET INVOICE IDs
         
         These invoices have already been
         filtered using invoice_date.
      ======================================== */

      const vendorInvoiceIds =
        new Set(
          vendorInvoices.map(
            invoice =>
              Number(
                invoice.id ||
                invoice.invoice_id
              )
          )
        );

      /* ========================================
         GET PAYMENTS FOR THOSE INVOICES
         
         IMPORTANT:
         payment_date is NOT checked.
         
         If a payment belongs to an invoice
         selected by invoice_date, it is included.
      ======================================== */

      const vendorPayments =
        allPayments.filter(
          payment =>
            Number(payment.vendor_id) ===
            Number(vendor.id) &&
            vendorInvoiceIds.has(
              Number(payment.invoice_id)
            )
        );

      /* ========================================
         INVOICE COUNT
      ======================================== */

      const invoiceCount =
        vendorInvoices.length;

      /* ========================================
         TOTAL INVOICE AMOUNT
      ======================================== */

      const totalInvoiceAmount =
        vendorInvoices.reduce(
          (total, invoice) =>
            total +
            Number(
              invoice.invoice_amount ||
              invoice.amount ||
              0
            ),
          0
        );

      /* ========================================
         TOTAL PAID AMOUNT
         
         Payments are connected using invoice_id.
         Payment date is ignored.
      ======================================== */

      const totalPaidAmount =
        vendorPayments.reduce(
          (total, payment) =>
            total +
            Number(
              payment.payment_amount || 0
            ),
          0
        );

      /* ========================================
         OUTSTANDING BALANCE
      ======================================== */
      const outstandingBalance = Math.max(totalInvoiceAmount - totalPaidAmount, 0);
      /* ========================================
            PENDING INVOICES
      ======================================== */
      const pendingInvoices =
        vendorInvoices.filter(invoice => {
          const invoiceAmount =
            Number(
              invoice.invoice_amount ||
              invoice.amount ||
              0
            );
          const invoiceId =
            Number(
              invoice.id ||
              invoice.invoice_id
            );
          const vendorId = Number(invoice.vendor_id);
          /* Find all payments for this invoice */
          const invoicePayments =
            allPayments.filter(
              payment =>
                Number(payment.invoice_id) === invoiceId &&
                Number(payment.vendor_id) === vendorId
            );
          /* Calculate total paid */
          const paidAmount =
            invoicePayments.reduce(
              (total, payment) =>
                total +
                Number(
                  payment.payment_amount || 0
                ),
              0
            );
          /* Calculate pending */
          const pendingAmount =
            Math.max(
              invoiceAmount - paidAmount,
              0
            );
          /* Pending invoice only */
          return pendingAmount > 0;
        }).length;

      /* ========================================
         LAST INVOICE DATE
      ======================================== */

      let lastInvoiceDate = "";

      if (vendorInvoices.length > 0) {
        lastInvoiceDate =
          [...vendorInvoices]
            .sort(
              (a, b) =>
                new Date(b.invoice_date) -
                new Date(a.invoice_date)
            )[0].invoice_date;
      }

      /* ========================================
         LAST PAYMENT DATE
         This is ONLY for displaying the
         last payment date.
         It does NOT affect paid amount.
      ======================================== */

      let lastPaymentDate = "";

      if (vendorPayments.length > 0) {
        lastPaymentDate =
          [...vendorPayments]
            .sort(
              (a, b) =>
                new Date(b.payment_date) -
                new Date(a.payment_date)
            )[0].payment_date;
      }
      /* ========================================
          PAYMENT STATUS
          Based ONLY on actual amounts
      ======================================== */

      let paymentStatus = "NOTPAID";

      if (
        totalInvoiceAmount > 0 &&
        totalPaidAmount >= totalInvoiceAmount
      ) {
        paymentStatus = "PAID";
      }
      else if (
        totalPaidAmount > 0 &&
        totalPaidAmount < totalInvoiceAmount
      ) {
        paymentStatus = "PARTIAL";
      }
      else {
        paymentStatus = "NOTPAID";
      }

      /* ========================================
         REPORT ROW
      ======================================== */

      reportData.push({
        vendor_id: vendor.id,
        vendor_name: vendor.vendor_name,
        phone_number: vendor.phone_number,

        invoice_count:
          invoiceCount,

        total_invoice_amount:
          totalInvoiceAmount,

        total_paid_amount:
          totalPaidAmount,

        outstanding_balance:
          outstandingBalance,

        pending_invoices:
          pendingInvoices,

        last_invoice_date:
          lastInvoiceDate,

        last_payment_date:
          lastPaymentDate,

        payment_status:
          paymentStatus
      });
    });

    /* ==========================================
       BAR CHART
       Based on invoice_date
    ========================================== */

    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec"
    ];

    const monthlyInvoiceMap = {};

    months.forEach(month => {
      monthlyInvoiceMap[month] = 0;
    });

    const selectedYear =
      this.state.selectedYear;

    filteredInvoices.forEach(invoice => {

      if (!invoice.invoice_date) {
        return;
      }

      const invoiceDate =
        new Date(invoice.invoice_date);

      if (isNaN(invoiceDate.getTime())) {
        return;
      }

      if (
        invoiceDate.getFullYear() !==
        Number(selectedYear)
      ) {
        return;
      }

      const monthName =
        months[invoiceDate.getMonth()];

      monthlyInvoiceMap[monthName] +=
        Number(
          invoice.invoice_amount ||
          invoice.amount ||
          0
        );
    });

    const barChartData =
      months.map(month => ({
        month,
        invoiceAmount:
          monthlyInvoiceMap[month]
      }));



    /* ==========================================
       UPDATE SUMMARY
    ========================================== */

    this.calculateSummary(
      reportData,
      todaySummary,
      yesterdaySummary,
      lastWeekSummary,
      lastMonthSummary,
      barChartData
    );
  };

  preparePaymentComparisonChart = () => {
    const {
      selectedVendor,
      invoices,
      payments,
      paymentComparisonYear
    } = this.state;

    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec"
    ];

    /* ==========================================
       EMPTY MONTH DATA
    ========================================== */

    const monthlyData = months.map((month, index) => ({
      month,
      monthIndex: index,
      totalAmount: 0,
      paidAmount: 0
    }));

    /* ==========================================
       VENDOR REQUIRED
    ========================================== */

    if (!selectedVendor) {
      this.setState({
        paymentComparisonChartData: monthlyData
      });

      return;
    }

    const vendorId = Number(selectedVendor);
    const selectedYear = Number(paymentComparisonYear);

    /* ==========================================
       PAYMENT MAP
  
       Key:
       vendor_id + invoice_id
  
       Value:
       TOTAL PAYMENT
    ========================================== */

    const paymentMap = {};

    (payments || []).forEach(payment => {

      const paymentVendorId =
        Number(payment.vendor_id);

      const paymentInvoiceId =
        Number(payment.invoice_id);

      if (!paymentVendorId || !paymentInvoiceId) {
        return;
      }

      if (paymentVendorId !== vendorId) {
        return;
      }

      const key =
        `${paymentVendorId}_${paymentInvoiceId}`;

      if (!paymentMap[key]) {
        paymentMap[key] = 0;
      }

      paymentMap[key] += Number(
        payment.payment_amount || 0
      );
    });

    /* ==========================================
       PROCESS INVOICES
    ========================================== */

    (invoices || []).forEach(invoice => {

      /* Vendor */

      if (
        Number(invoice.vendor_id) !== vendorId
      ) {
        return;
      }

      /* Invoice date */

      if (!invoice.invoice_date) {
        return;
      }

      const invoiceDate =
        new Date(invoice.invoice_date);

      if (isNaN(invoiceDate.getTime())) {
        return;
      }

      /* Year */

      if (
        invoiceDate.getFullYear() !==
        selectedYear
      ) {
        return;
      }

      /* Month */

      const monthIndex =
        invoiceDate.getMonth();

      /* Invoice amount */

      const invoiceAmount =
        Number(
          invoice.invoice_amount ||
          invoice.amount ||
          0
        );

      /* Invoice ID */

      const invoiceId =
        Number(
          invoice.id ||
          invoice.invoice_id
        );

      if (!invoiceId) {
        return;
      }

      /* ==========================================
         GET ALL PAYMENTS FOR THIS INVOICE
         
         PAYMENT DATE IS NOT CHECKED
      ========================================== */

      const paymentKey =
        `${vendorId}_${invoiceId}`;

      const paidAmount =
        Number(paymentMap[paymentKey] || 0);

      /* ==========================================
         ADD TO MONTH
      ========================================== */

      monthlyData[monthIndex].totalAmount +=
        invoiceAmount;

      monthlyData[monthIndex].paidAmount +=
        paidAmount;
    });

    /* ==========================================
       ROUND FINAL VALUES
    ========================================== */

    const finalChartData =
      monthlyData.map(item => ({
        month: item.month,

        totalAmount:
          Number(
            item.totalAmount.toFixed(2)
          ),

        paidAmount:
          Number(
            item.paidAmount.toFixed(2)
          )
      }));

    console.log(
      "Selected Vendor:",
      vendorId
    );

    console.log(
      "Selected Year:",
      selectedYear
    );

    console.log(
      "Total vs Paid Chart:",
      finalChartData
    );

    /* ==========================================
       UPDATE CHART
    ========================================== */

    this.setState({
      paymentComparisonChartData:
        finalChartData
    });
  };

  handleYearChange = (e) => {
    const year = Number(e.target.value);
    this.setState({ selectedYear: year },
      () => {
        this.generateVendorReport();
      }
    );
  };
  handlePaymentComparisonYearChange = (e) => {
    const year = Number(e.target.value);
    this.setState(
      { paymentComparisonYear: year },
      () => {
        this.preparePaymentComparisonChart();
      }
    );
  };
  handleVendorMonthYearChange = (e) => {
    const year = Number(e.target.value);
    this.setState(
      {
        vendorMonthYear: year
      },
      () => {
        this.prepareVendorMonthChart();
      }
    );
  };
  handleVendorMonthChange = (e) => {
    const month = e.target.value;
    this.setState(
      {
        vendorMonth: month
      },
      () => {
        this.prepareVendorMonthChart();
      }
    );
  };
  /* =====================================================
    Calculate Summary Cards
  ====================================================== */
  calculateSummary = (
    reportData,
    todaySummary,
    yesterdaySummary,
    lastWeekSummary,
    lastMonthSummary,
    barChartData
  ) => {
    let filteredReport = [...reportData];
    if (this.state.selectedVendor !== "") {
      filteredReport = filteredReport.filter(
        vendor =>
          Number(vendor.vendor_id) ===
          Number(this.state.selectedVendor)
      );
    }
    if (this.state.searchText.trim() !== "") {
      const search =
        this.state.searchText
          .toLowerCase()
          .trim();
      filteredReport = filteredReport.filter(
        vendor =>
          (vendor.vendor_name || "")
            .toLowerCase()
            .includes(search)
      );
    }
    filteredReport.sort((a, b) =>
      (a.vendor_name || "")
        .localeCompare(b.vendor_name || "")
    );
    /* Calculate totals AFTER filtering */
    const totalVendors = filteredReport.length;
    const totalInvoiceAmount = filteredReport.reduce(
      (total, vendor) =>
        total +
        Number(
          vendor.total_invoice_amount || 0
        ),
      0
    );
    const totalPaidAmount = filteredReport.reduce(
      (total, vendor) =>
        total +
        Number(
          vendor.total_paid_amount || 0
        ),
      0
    );
    const totalOutstandingBalance = filteredReport.reduce(
      (total, vendor) =>
        total +
        Number(
          vendor.outstanding_balance || 0
        ),
      0
    );
    const totalPendingInvoices = filteredReport.reduce(
      (total, vendor) =>
        total +
        Number(
          vendor.pending_invoices || 0
        ),
      0
    );
    /* ==========================
       Update State
    ========================== */
    this.setState({
      vendorReport: filteredReport,

      barChartData,

      totalVendors,
      totalInvoiceAmount,
      totalPaidAmount,
      totalOutstandingBalance,
      totalPendingInvoices,

      todaySummary,
      yesterdaySummary,
      lastWeekSummary,
      lastMonthSummary
    });
  };
  /* =====================================================
    Export Vendor Report
  ====================================================== */
  onExport = () => {
    const data = this.state.vendorReport.map((vendor, index) => ({
      "S.No": index + 1,
      "Vendor Name": vendor.vendor_name,
      "Phone Number": vendor.phone_number,
      "Invoice Count": vendor.invoice_count,
      "Total Invoice Amount": vendor.total_invoice_amount,
      "Total Paid Amount": vendor.total_paid_amount,
      "Outstanding Balance": vendor.outstanding_balance,
      "Pending Invoices": vendor.pending_invoices,
      "Last Invoice Date": vendor.last_invoice_date,
      "Last Payment Date": vendor.last_payment_date,
      "Payment Status": vendor.payment_status,
    }));
    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(
      workbook,
      worksheet,
      "Vendor Report"
    );
    const excelBuffer = XLSX.write(
      workbook,
      {
        bookType: "xlsx",
        type: "array",
      }
    );
    const blob = new Blob(
      [excelBuffer],
      {
        type: "application/octet-stream",
      }
    );
    saveAs(blob, "VendorReport.xlsx");
  };
  /* =====================================================
      Render
  ====================================================== */
  render() {
    return (
      <VendorReportComponent

        loading={this.state.loading}

        activePeriod={this.state.activePeriod}
        changePeriod={this.changePeriod}
        /* ======================
            Report Data
        ======================= */
        vendorReport={this.state.vendorReport}
        /* ======================
            Vendor Dropdown
        ======================= */
        vendors={this.state.vendors}
        selectedVendor={this.state.selectedVendor}
        onVendorChange={this.onVendorChange}

        /* ======================
            Summary Cards
        ======================= */
        totalVendors={this.state.totalVendors}
        totalInvoiceAmount={this.state.totalInvoiceAmount}
        totalPaidAmount={this.state.totalPaidAmount}
        totalOutstandingBalance={this.state.totalOutstandingBalance}
        totalPendingInvoices={this.state.totalPendingInvoices}

        /* ======================
            Dashboard Cards
        ======================= */
        todaySummary={this.state.todaySummary}
        yesterdaySummary={this.state.yesterdaySummary}
        lastWeekSummary={this.state.lastWeekSummary}
        lastMonthSummary={this.state.lastMonthSummary}
        /* ======================
            Charts
        ======================= */
        selectedYear={this.state.selectedYear}
        yearList={this.yearList}
        onYearChange={this.handleYearChange}
        barChartData={this.state.barChartData}
        /* ======================
            Total vs Paid Chart
        ======================= */
        paymentComparisonYear={this.state.paymentComparisonYear}
        onPaymentComparisonYearChange={this.handlePaymentComparisonYearChange}
        paymentComparisonChartData={this.state.paymentComparisonChartData}
        /* ======================
            Filters
        ======================= */
        reportType={this.state.reportType}
        fromDate={this.state.fromDate}
        toDate={this.state.toDate}
        applyDateFilter={this.applyDateFilter}
        clearDateFilter={this.clearDateFilter}
        searchText={this.state.searchText}

        /* ======================
            Events
        ======================= */
        onSearchChange={this.onSearchChange}
        onReportTypeChange={this.onReportTypeChange}
        onFromDateChange={this.onFromDateChange}
        onToDateChange={this.onToDateChange}
        resetFilters={this.resetFilters}
        refreshData={this.refreshData}
        onExport={this.onExport}
        /* ======================
            Vendor + Month Chart
        ====================== */
        vendorMonthChartData={this.state.vendorMonthChartData}
        vendorMonth={this.state.vendorMonth}
        vendorMonthYear={this.state.vendorMonthYear}
        onVendorMonthChange={this.handleVendorMonthChange}
        onVendorMonthYearChange={this.handleVendorMonthYearChange}
        /* ======================
            Pending Payments
        ======================= */
        showPendingPayments={this.state.showPendingPayments}
        pendingPaymentsTable={this.state.pendingPaymentsTable}
        onPendingPaymentsClick={this.togglePendingPayments}
      />
    );
  }
}
export default VendorReportContainer;
